import React, {Component} from 'react';
import "./FooterMp.scss"

export default class FooterMp extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="footerMp">
                <div className="footerMp-content">
                    <div className="left">
                        <div className="item">
                            <div className="text">
                                电话：0510-87029605
                            </div>
                        </div>
                        <div className="item">
                            <div className="text">
                                邮箱：zhongya56@126.com
                            </div>
                        </div>
                        <div className="item">
                            <div className="text">
                                地址：宜兴经济技术开发区北环路东侧
                            </div>
                        </div>
                    </div>
                </div>
                <div className="record">
                    宜兴市交运物流信息科技有限公司 备案号： <a style="color: blue;" target="_blank" href="https://beian.miit.gov.cn/" style={{'color': '#1890ff', 'text-decoration':'underline'}}>苏ICP备18049070号-1</a>
                </div>
            </div>
        );
    }
}
